import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import queryString from "query-string";
import { IoFunnel } from "react-icons/io5";
import { bindActionCreators } from "redux";

import PtoRequestService from "../../../services/ptoRequestService";
import * as PtoRequestActions from "../../../actions/ptoRequestActions";
import PtoRequestListFilters from "./PtoRequestListFilters";
import PtoRequestList from "./PtoRequestList";
import Loading from "../../common/Loading";
import PtoUserDisplay from "../components/PtoUserDisplay";

import HeaderWrapper from "../../common/HeaderWrapper";

import {
  getFilterState,
  saveFilterState,
  customToast as toast
} from "../../../utils";
import "./PtoRequesListPage.scss";

const PtoRequestListPage = ({
  auth,
  history,
  isMobile,
  codes,
  actions,
  ptoBalance
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(null);
  const [showFilters, setShowFilters] = useState(true);
  const fetchData = useCallback(async (dataToFilter) => {
    try {
      setLoading(true);
      const query = queryString.stringify(
        { ...dataToFilter },
        {
          arrayFormat: "bracket"
        }
      );

      const result = await PtoRequestService.getByUser(query);
      setData(result);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!filters && codes && codes.length > 0 && !loading) {
      let newFilters = getFilterState("PTOREQUEST_FILTERS");
      newFilters = {
        ...newFilters,
        page: 0,
        pageSize: 50,
        employee: auth.user._id
      };
      setFilters(newFilters);
      saveFilterState("PTOREQUEST_FILTERS", newFilters);
      fetchData(newFilters);
    }
  }, [auth.user._id, codes, data, fetchData, filters, loading]);

  useEffect(() => {
    if (!ptoBalance) {
      actions.getPtoRequestBalance(auth.user._id);
    }
  }, [actions, ptoBalance, auth]);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleChange = (name) => async (value) => {
    let newFilters = {
      ...getFilterState("PTOREQUEST_FILTERS"),
      page: 0
    };

    setLoading(true);
    if (Array.isArray(value)) {
      newFilters = {
        ...newFilters,
        [name]: value.map((v) => v.value)
      };
    } else {
      newFilters = Object.keys(filters).reduce((acc, curr) => {
        if (curr !== name) {
          acc[curr] = filters[curr];
        }
        return acc;
      }, {});
    }

    newFilters.pageSize = name === "pageSize" ? value : filters.pageSize;

    await saveFilterState("PTOREQUEST_FILTERS", newFilters);
    await fetchData(newFilters);
    await setFilters(newFilters);
    setLoading(false);
  };

  const handlePageSizeChange = (pageSize) => {
    handleChange("pageSize")(pageSize);
  };
  const handlePageChange = (page) => {
    handleChange("page")(page);
  };

  const handleReset = () => {
    const newFilters = {
      page: 0,
      pageSize: 50,
      employee: auth.user._id
    };
    setFilters(newFilters);
    saveFilterState("PTOREQUEST_FILTERS", newFilters);
    fetchData(newFilters);
  };

  const handleAddRequest = () => {
    history.push("/app/pto/add");
  };
  const handleRowClick = (rowInfo) => {
    history.push(`/app/pto/${rowInfo.original._id}`);
  };

  return (
    <div className="report-page">
      <HeaderWrapper
        breadcrumbs={[{ label: "My Personal Time" }]}
        onClickAdd={handleAddRequest}
        onClickAction={[
          { action: () => setShowFilters(!showFilters), icon: <IoFunnel /> }
        ]}
      />
      {/* display section */}
      <PtoUserDisplay data={ptoBalance} />

      {/* list section */}

      <PtoRequestListFilters
        show={showFilters}
        filters={filters}
        handleChange={handleChange}
        handleReset={handleReset}
        loading={loading}
        // handleSearchChange={handleSearchChange}
        handleSubmit={handleSubmit}
      />
      {loading && (
        <div className="loading-loader-load-container">
          <Loading active={loading} />
        </div>
      )}
      {!loading && data && Array.isArray(data) && data.length > 0 && (
        <PtoRequestList
          data={data}
          loading={loading}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          page={filters && filters.page}
          pageSize={filters && filters.pageSize}
          onRowClick={handleRowClick}
          isMobile={isMobile}
        />
      )}
      {!loading && data && Array.isArray(data) && data.length === 0 && (
        <div className="loading">
          <h4 style={{ opacity: 0.15 }}>No PTO requests found</h4>
        </div>
      )}
    </div>
  );
};

PtoRequestListPage.propTypes = {
  auth: PropTypes.object,
  history: PropTypes.object,
  isMobile: PropTypes.bool,
  codes: PropTypes.array,
  actions: PropTypes.object,
  ptoBalance: PropTypes.object
};
function mapStatesToProps(state) {
  return {
    auth: state.reducers.auth,
    codes: state.reducers.codes,
    ptoBalance: state.reducers.ptoBalance
  };
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...PtoRequestActions
    },
    dispatch
  )
});
export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(PtoRequestListPage);
